import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue"
import PreLoader from "./components/Layouts/PreLoader.vue"
import MainHeader from "./components/Layouts/MainHeader.vue"
import MainSidebar from "./components/Layouts/MainSidebar.vue"
import stateStore from "./utils/store"
import GlobalLoader from '@/components/Layouts/GlobalLoader.vue'
import { useLoaderStore } from '@/stores/loader'
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isPreLoading = ref<boolean>(true)
const stateStoreInstance = stateStore

const loaderStore  = useLoaderStore()
const { isAuthenticated } = storeToRefs(useAuthStore())

onMounted(() => {
  setTimeout(() => {
      isPreLoading.value = false;
    }, 2000)
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isPreLoading.value)
      ? (_openBlock(), _createBlock(PreLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(GlobalLoader, {
      modelValue: _unref(loaderStore).isLoading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(loaderStore).isLoading) = $event)),
      backdropClosable: false
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Please wait while we process your request… ", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(isAuthenticated))
      ? (_openBlock(), _createBlock(MainHeader, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
    'main-content expanded js-container',
    { collapsed: _unref(stateStoreInstance).open },
  ]),
      style: _normalizeStyle(!_unref(isAuthenticated) ? { paddingLeft: '0', paddingTop: '101px' } : {})
    }, [
      (_unref(isAuthenticated))
        ? (_openBlock(), _createBlock(MainSidebar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ], 6)
  ], 64))
}
}

})